import { bareApi } from './bareApi';

/**
 * The in-flight refresh, if there is one.
 *
 * Concurrent 401s must not each fire their own refresh: a dashboard issues
 * several requests in parallel, so one expired token produces several 401s at
 * once, and with rotating refresh tokens the first call invalidates the token
 * the others are still using — so all but one fail and force a sign-out that was
 * never necessary. Every caller awaits the same promise instead.
 */
let refreshPromise: Promise<unknown> | null = null;

export const refreshSession = (): Promise<unknown> =>
  // bareApi, not api: a 401 on the refresh itself must not re-enter the response
  // interceptor and trigger another refresh.
  (refreshPromise ??= bareApi.post('/v1/user/auth/refresh').finally(() => {
    refreshPromise = null;
  }));
